import 'menujs';
import { getElementById, attachEventToElements, preloadImg, AppHooksType, getAppType, ApplicationType } from './utils';

import * as indexPage from './index';
import * as featuresPage from './features';

var Sizzle = require('sizzlejs');
window['Sizzle'] = Sizzle;
window['$'] = Sizzle;

const appHooks: AppHooksType = {
    onwebp: null
};

const appType = getAppType();

function initApplication() {
    getElementById('icon-header').addEventListener('click', () => {
        location.href = 'index.html';
    });

    getElementById('year').innerText = new Date().getFullYear().toString();


    // init page
    switch (appType) {
        case ApplicationType.index: {
            indexPage.init(appHooks);
            break;
        }
        case ApplicationType.features: {
            featuresPage.init(appHooks);
            break;
        }
    }


    Modernizr.on('webp', function (supported) {
        supported = false;
        appHooks.onwebp(supported);
    });
}

export {
    initApplication
};

domIsReady(function () {
    initApplication();
});